import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import {getAppCfg, getBrowser, getCountryDefault, setContacts} from '../../utils/common'
import { connection } from '../../../portal.config';
import RegisterVerificationView from '../register/RegisterVerificationView';
import CredentialsView from './CredentialsView';
import { countries_agreement } from '../../../portal.menu.config';
import { CyprusFlagIcon } from '../../components/icons';
const styles = theme => ({

});
function CredentialsController(props){
    const config = getAppCfg()
    let agreement_countries = config&&config.contact&&config.contact.agreement_countries?config.contact.agreement_countries:null
    let country_default = getCountryDefault(agreement_countries);
    const [active, setActive] = useState('main');
    const [method_select, onSelectMethod] = useState('PHONE');
    const [verify_type, onSelectVerify] = useState('EMAIL');
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({});
    const [register_info, setRegisterInfo] = useState({
                            country_code: country_default.value,
                        })
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState('');
    const [validation, setValiadation] = useState({});
    const [contact, setContact] = useState(null);
    const [country_select, setSelectCountry] = useState(country_default);

    const onAuthCredentials = async(values) => {
        const config = getAppCfg()
        let jwtDecode = require('jwt-decode');
        const contact = props.contact
        let contact_id = null
        const access_token = contact&&contact.access_token?contact.access_token:null
        if (access_token){
            contact_id = jwtDecode(access_token).sub
            console.log('jwtDecode(access_token)===', jwtDecode(access_token))
        }
        if(!contact_id){
            showAlert('ERROR', t('Can not access token'))
            return;
        }

        let temp_register_info = { ...register_info };
        temp_register_info.PHONE = values.PHONE
        temp_register_info.EMAIL = values.EMAIL
        temp_register_info.password = values.password

        setRegisterInfo(prevState => ({
            ...prevState,
            PHONE:  values.PHONE,
            EMAIL: values.EMAIL,
            password: values.password,
        }));


        onShowLoading(true);
        if(config.auth_support&&config.auth_support.email_password){
            if (temp_register_info.password!==values.confirm_password){
                showAlert(t('ERROR'), t('ENTER_THE_SAME_PASSWORD'));
                return
            }
            try {
                    let result = await crmServices.contacts.credentialsByEmail(temp_register_info.EMAIL, temp_register_info.password, contact_id, access_token )
                    //console.log('onRegister===',result)
                    if (result.code == 'OK') {
                        onShowLoading(false);
                        showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'))
                        //navigateAndReset(this.props.navigation,"Login");
                    } else if (result.code === 'INVALID_CONTACTPASSWORD_EXCEPTION') {
                        showAlert('ERROR', t('INVALID_CONTACTPASSWORD_EXCEPTION'));
                    } else {
                        showAlert('ERROR', t(result.code))
                    }
                } catch (error) {
                    console.log("register by phone exception:", error);
                    showAlert('ERROR', t('EXCEPTION_PROCESS'))
                }
        }
        else{
                try {
                    let result = await crmServices.contacts.credentialsByPhone(temp_register_info.PHONE, contact_id, temp_register_info.country_code, access_token)
                    //console.log('onRegister==PHONE=',result)
                    if (result.code == 'OK') {
                        if (result.data && result.data.auth_otp) {
                            setAuthOtp(result.data.auth_otp);
                            setObfuscatedValue(result.data.obfuscated_value);
                        }
                        onShowLoading(false);
                        setActive('verify');
                    } else {
                        showAlert('ERROR', t(result.code))
                    }
                } catch (error) {
                    console.log("register by phone exception:", error);
                    showAlert('ERROR', t('EXCEPTION_PROCESS'));
                }
        }
        onShowLoading(false);
    }
    const onVerifyOTP = async(code)=> {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.validateCredentialsOTP({ phone: null, auth_otp: auth_otp, otp: code.verification_code });
            //console.log('result=======', result)
            if (result.code === 'OK') {
                setContact(result.data)
                onShowLoading(false);
                setActive('auth-cre');
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const onResendCode = async() => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendCredentialsOTP({ send_method: verify_type , name: method_select, value: register_info[method_select] });
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                }
                showAlert('ERROR', t('OTP_RESEND_SUCCESS'))
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }


    const onSelectCountry = (value) => {

        setRegisterInfo(prevState => ({
            ...prevState,
            country_code: value.value
        }));
        setSelectCountry(value)
    }
    const showAlert = (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }
    return (
        <div>
        {active==='main'&&<CredentialsView
            onSubmit={onAuthCredentials}
            showAlert={showAlert}
            onShowLoading={onShowLoading}
            register_info = {register_info}
            contact = {props.contact && props.contact.contact && props.contact.contact.first_name ? props.contact.contact.first_name : ''}
            agreement_countries = {agreement_countries}
            onSelectCountry = {onSelectCountry}/>}
        {active==='verify'&&<RegisterVerificationView
            onSubmit={onVerifyOTP}
            onResend={onResendCode}
            obfuscated_value={obfuscated_value}
            email = {verify_type==='EMAIL'}/>}    

        <ModalAlert
            open={error.showAlert}
            onClose={onCloseAlert}
            hideHeader={true}
            message={error.message}
            error={error.status}
            title={error.title}
        />
        {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}

export default withStyles(styles)(withTranslation()(CredentialsController));